import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import { RadioGroupSetProps } from '@shared/components/inputs/Radio/RadioGroupSet.types';

const RadioGroupSet = ({ options, name, hideIcon, ...props }: RadioGroupSetProps) => {
  return (
    <RadioGroup
      name={name}
      sx={{
        ...(props?.gap && { gap: props.gap }),
      }}
      {...props}
    >
      {options.map((option, index) => {
        const { value, label, margin, ...restOptionProps } = option;

        return (
          <FormControlLabel
            key={`${value}-${index}`}
            value={value}
            label={label}
            control={
              <Radio
                disableFocusRipple
                disableRipple
                sx={{
                  display: hideIcon ? 'none' : 'flex',
                }}
              />
            }
            sx={{
              ...(margin && { margin }),
            }}
            {...restOptionProps}
          />
        );
      })}
    </RadioGroup>
  );
};

export default RadioGroupSet;
